import angular from 'angular';

import RwTermsOfUseDialogComponent from './rw-terms-of-use-dialog-component';
import { RwTermsOfUseDialogController } from './rw-terms-of-use-dialog-controller';

export default angular
  .module('rw-terms-of-use-dialog', [])
  .controller('RwTermsOfUseDialogController', RwTermsOfUseDialogController)
  .component('rwTermsOfUseDialog', RwTermsOfUseDialogComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/rw-terms-of-use-dialog-module.js